import { useCallback, useEffect, useMemo, useState } from 'react'

function useHeightListener(): [(node: any) => void, number | undefined] {
  const [heightState, setHeightState] = useState<number | undefined>(undefined)
  const [isNodeLoaded, setIsNodeLoaded] = useState(false)
  const [node, setNode] = useState<any>(undefined)
  const checkRef = useCallback((node: any) => {
    if (node !== null) {
      setNode(node)
      setHeightState(node.getBoundingClientRect().height)
      setIsNodeLoaded(true)
    }
  }, [])

  const resizeObserver = useMemo(() => {
    const result = new ResizeObserver((entries) => {
      const height = entries[0].contentRect.height
      setHeightState(height)
    })
    return result
  }, [])

  useEffect(() => {
    if (isNodeLoaded && !!node) {
      resizeObserver.observe(node)
    }
  }, [isNodeLoaded, node, resizeObserver])

  return [checkRef, heightState]
}

export default useHeightListener
